export const viewStyles = {
  container: { p: 3, display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' },
  headerBox: { display: 'flex', alignItems: 'center', mb: 1 },
  headerText: { flexGrow: 1, color: '#393946', fontFamily: 'Plus Jakarta Sans', fontWeight: 400, fontSize: '16px' },
  secondaryText: { mb: 3 },
  addDomainBox: { display: 'flex', alignItems: 'center', mb: 2.5 },
  textField: { mr: 1.5, flexGrow: 1 },
  addButton: { textTransform: 'none', minWidth: '120px' },
  contentArea: { flexGrow: 1, overflowY: 'auto', mb: 2 },
  noDomainsText: { textAlign: 'center', mt: 3, color: 'text.secondary' },
  domainList: { pr: 1 },
  footer: { mt: 'auto', borderColor: 'divider', display: 'flex', justifyContent: 'flex-end' },
  doneButton: {
    borderRadius: '16px',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    padding: '8px 8px',
    backgroundColor: '#0246F8',
    boxShadow: 'none',
    color: '#fff',
    textTransform: 'none',
    flexGrow: 1,
    minWidth: '120px',
    '&:hover': { backgroundColor: '#1d4ed8' },
    '&.Mui-disabled': {
      backgroundColor: '#e0e0e0',
      color: '#757575'
    }
  },
  backButton: {
    borderRadius: '16px',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    padding: '8px 8px',
    boxShadow: 'none',
    textTransform: 'none',
    flexGrow: 1,
    minWidth: '120px',
    '&.Mui-disabled': {
      backgroundColor: '#e0e0e0',
      color: '#757575'
    }
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    flexDirection: 'column',
    gap: 2
  },
  successMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    p: 3,
    minHeight: '200px',
    gap: 1
  }
}
